<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmGroup"
      :title="this.$lang.TravelReason.TitleForm"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label><small class="text-danger" v-if="form.nome.required">*</small> {{$lang.TravelReason.LabelName}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="$lang.TravelReason.PlaceholderEnterName"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"
                          @keypress="onToUpper($event, form.nome)"></b-form-input>
          </div>
        </div>
        <div class="col-md-4">
          <label><small class="text-danger" v-if="form.periodicidade.required">*</small> {{$lang.TravelReason.LabelFrequency}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.periodicidade.value" :options="form.periodicidade.options" @change="onChangeFrequency">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                <option :value="true">{{$lang.Common.Yes}}</option>
                <option :value="false">{{$lang.Common.No}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label><small class="text-danger" v-if="form.periodicidadeDias.required">*</small> {{$lang.TravelReason.LabelFrequencyDays}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="$lang.TravelReason.PlaceholderEnterFrequencyDays"
                          v-model="form.periodicidadeDias.value"
                          :size="form.periodicidadeDias.maxlength"
                          :required="form.periodicidadeDias.required"
                          :state="form.periodicidadeDias.state">
            </b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-4">
          <label for="txtGroup"><small class="text-danger" v-if="form.exibirEmReembolsoGeral.required">*</small> {{$lang.TravelReason.LabelViewTravelRefund}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.exibirEmReembolsoGeral.value" :options="form.exibirEmReembolsoGeral.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                <option :value="true">{{$lang.Common.Yes}}</option>
                <option :value="false">{{$lang.Common.No}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtGroup"><small class="text-danger" v-if="form.exibirEmViagemAdm.required">*</small> {{$lang.TravelReason.LabelViewADMTravelExpense}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.exibirEmViagemAdm.value" :options="form.exibirEmViagemAdm.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                <option :value="true">{{$lang.Common.Yes}}</option>
                <option :value="false">{{$lang.Common.No}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label for="txtDescription"> {{$lang.TravelReason.LabelDescription}}:</label>
          <b-form-textarea id="txtDescription"
                      name="txtDescription"
                      v-model="form.descricao.value"
                      :placeholder="$lang.TravelReason.PlaceholderEnterDescription"
                      :rows="form.descricao.rows"
                      :size="form.descricao.maxlength"
                      :noResize="form.descricao.noResize"></b-form-textarea>
          <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
        </div>
      </div>
    </Forms>
    <Tables ref="tableGrid"
            :columns="[
              $lang.TravelReason.DataTable.Name,
              $lang.TravelReason.DataTable.Frequency,
              $lang.TravelReason.DataTable.TravelRefund,
              $lang.TravelReason.DataTable.TravelExpense,
              $lang.Common.DataTable.Status,
              $lang.Common.DataTable.ActionDate,
              $lang.Common.DataTable.AccountAction,
              $lang.Common.DataTable.Actions]"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.nome" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.PeriodicidadeDias ? obj.PeriodicidadeDias  : $lang.Common.No" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.exibirEmReembolsoGeral ? $lang.Common.Yes : $lang.Common.No" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.exibirEmViagemAdm ? $lang.Common.Yes : $lang.Common.No" />
        <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
        <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataAcao" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.nomeContaAcao" />
        <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import TravelReason from './travelreason.js'
export default TravelReason
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/travelreason/travelreason.vue